import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

export class Utilities {

  private static datePipe: DatePipe = new DatePipe('en-US');
  constructor() {

  }
    public static EMAIL_REGEXP =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /**
     *  Descubre si los objetos son tradicionalmente iguales entre sí,
     * como puede suponer que alguien más ya habría puesto esta función en vanilla JS.
     * Una cosa a tener en cuenta es que utiliza una comparación coercitiva (==) en las propiedades que
     * tienen ambos objetos, no una comparación estricta (===).
     * Otra nota importante es que el método solo te dice si `compare` tiene
     * todos los parámetros iguales a ` base`, no al revés
     *
     * @param base El objeto base con el que le gustaría comparar otro objeto
     * @param compare El objeto a comparar con la base.
     * @returns boolean que indica si los objetos tienen o no las mismas propiedades y esas propiedades son ==
     */
    public static isSameObject(base: any, compare: any): boolean {

        if (!base && !compare) return true;
        if (!base || !compare) return false;

        // loop through all properties in base object
        for (const baseProperty in base) {

            // determine if comparrison object has that property, if not: return false
            if (compare.hasOwnProperty(baseProperty)) {
                switch (typeof base[baseProperty]) {
                    // if one is object and other is not: return false
                    // if they are both objects, recursively call this comparison function
                    case 'object':
                        if (compare[baseProperty] === null && base[baseProperty]) {
                            return true;
                        }
                        // tslint:disable-next-line:max-line-length
                        if (typeof compare[baseProperty] !== 'object' || !this.isSameObject(base[baseProperty], compare[
                            baseProperty])) {
                            return false;
                        }
                        break;
                    // if one is function and other is not: return false
                    // if both are functions, compare function.toString() results
                    case 'function':
                        // tslint:disable-next-line:max-line-length
                        if (typeof compare[baseProperty] !== 'function' || base[baseProperty].toString() !== compare[baseProperty]
                            .toString()) {
                            return false;
                        }
                        break;
                    // otherwise, see if they are equal using coercive comparison
                    default:
                        if (base[baseProperty] !== compare[baseProperty]) { return false; }
                }
            } else {
                return false;
            }
        }

        // returns true only after false HAS NOT BEEN returned through all loops
        return true;
    }

    /**
     * Clona el objeton con las siguientes caracteristicas:
     *
     * Properties: Yes
     * Methods: No
     * Deep Copy: Yes
     *
     * @static
     * @param {any} obj
     * @returns
     *
     * @memberOf Utilities
     */
    public static deepCloneObject(obj) {
        let objectClon: any;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' !== typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            objectClon = new Date();
            objectClon.setTime(obj.getTime());
            return objectClon;
        }

        // Handle Array
        if (obj instanceof Array) {
            objectClon = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                objectClon[i] = this.deepCloneObject(obj[i]);
            }
            return objectClon;
        }

        // Handle Object
        if (obj instanceof Object) {
            objectClon = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) objectClon[attr] = this.deepCloneObject(obj[attr]);
            }
            return objectClon;
        }

        throw new Error('Unable to clone obj! Its type isn\'t supported.');
    }

    public static removeElementByKeyFromArray(array: any[], key: string, value: any) {
        const index = array.findIndex((obj) => obj[key] === value);
        if (index > -1) {
            array.splice(index, 1);
        }
    }

    public static objectClone(obj: object): object {
        return Object.assign({}, obj);
    }

    /**
     * [imgToData description]
     * @param  {string}          url [description]
     * @return {Promise<object>}     [description]
     */
    // tslint:disable:only-arrow-functions
    public static imgToData(url: string): Promise<object> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            // tslint:disable:space-before-function-paren
            xhr.onload = function () {
                const reader = new FileReader();
                reader.onloadend = function () {
                    const image = new Image();
                    image.src = reader.result as string;
                    image.crossOrigin = 'Anonymous';
                    image.onload = function () {
                        resolve({ data: reader.result, imgHeight: image.height, imgWidth: image.width });
                    };
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        });
    }

    /**
     * [goFullScreen description]
     * @param  {any}    element [description]
     * @return {[type]}         [description]
     */
    public static goFullScreen(element: any) {

        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }

    }

    /**
     * [exitFullScreen description]
     * @param  {any}    element [description]
     * @return {[type]}         [description]
     */
    public static exitFullScreen(element: any) {

        const doc = document as any;
        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
            doc.webkitExitFullscreen();
        } else if (doc.mozCancelFullScreen as any) {
            doc.mozCancelFullScreen();
        } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen();
        }
    }

    public static isUrlValid(url: string) {
        const res = url.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        if (res == null) {
            return false;
        } else {
            return true;
        }
    }

    public static getLocation(href: string) {
        const l = document.createElement('a');
        l.href = href;
        return l;
    }

    public static getParameterByName(name, url) {
        if (!url) { url = window.location.href; }
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) { return null; }
        if (!results[2]) { return ''; }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    public static removeAccents(s) {
        let r = s.toLowerCase();
        r = r.replace(new RegExp(/\s/g), '');
        r = r.replace(new RegExp(/[àáâãäå]/g), 'a');
        r = r.replace(new RegExp(/[èéêë]/g), 'e');
        r = r.replace(new RegExp(/[ìíîï]/g), 'i');
        r = r.replace(new RegExp(/[òóôõö]/g), 'o');
        r = r.replace(new RegExp(/[ùúûü]/g), 'u');

        r = r.replace(new RegExp(/[ÀÁÂÄ]/g), 'A');
        r = r.replace(new RegExp(/[ÈÉÊË]/g), 'E');
        r = r.replace(new RegExp(/[ÌÍÎÏ]/g), 'I');
        r = r.replace(new RegExp(/[ÓÒÓÔÖ]/g), 'O');
        r = r.replace(new RegExp(/[ÙÚÛÜ]/g), 'U');

        return r;
    }

    public static removeFromArray(e: any, array: any[]) {

        const index = array.indexOf(e);
        if (index > -1) {
            array.splice(index, 1);
        }
    }

    public static substractArrayAfromB(a: any[], b: any[], key: string) {

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < b.length; i++) {
            const element = b[i];
            Utilities.removeElementByKeyFromArray(a, key, element[key]);
        }
    }



    // https://stackoverflow.com/questions/7313395/case-insensitive-replace-all
    public static removeSubstringRegardlessOfCase(str, strReplace, strWith) {
        const esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const reg = new RegExp(esc, 'ig');
        return str.replace(reg, strWith);
    }

    /**
     * Obtiene la extensión de archivo a partir del mimetype
     *
     * @static
     * @param {string} mimeType
     * @returns {string}
     * @memberof Utilities
     */
    public static getMimeTypeExtension(mimeType: string): string {
        // return MimeTypes.extension(mimeType)
        return '';
    }

    /**
     * Obntiene el mimetype a partir de una extensión o nombre de archivo
     *
     * @static
     * @param {string} extension
     * @returns {string}
     * @memberof Utilities
     */
    public static getMimeType(extension: string): string {
        // return MimeTypes.lookup(extension)
        return '';
    }

    public static isOnlyNumbers(cad: string) {

        return (/^([0-9][0-9]+|[1-9])$/.test(cad));
    }

    public static resizeBase64Image(imageBase64: string, width: number, height: number): Observable<string> {

        return new Observable(observer => {

            const myImage = new Image();
            myImage.onload = () => {
                try {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(myImage, 0, 0, width, height);
                    const resizedBase64Img = canvas.toDataURL();
                    observer.next(resizedBase64Img);
                    observer.complete();
                } catch (error) {
                    observer.error(error);
                }
            };
            myImage.src = imageBase64;

        });
    }

    public static isSQLDate(value): boolean {

        const sqlDateRegExp =
            /(?:199[0-9]|20[0-9][0-9])-(?:0[1-9]|1[0-2])-(?:[0-2][0-9]|3[0-1])/; // Valida formatos del tipo aaaa-mm-dd
        return sqlDateRegExp.test(value);
    }

    public static transformDate(date, format) {
      return this.datePipe.transform(date, format);
    }

}
